module.exports = __webpack_public_path__ + "media/images/real-softex-40a406a25b8545be4d20b8bddf571f53.png";